var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarButtonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 47,
    height: 47,
    rx: 12,
    fill: "#E1EAF6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar (2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2984 36.7854H34.487C36.3065 36.7854 37.7854 35.3257 37.7854 33.5298V13.9968C37.7854 12.2009 36.3065 10.7415 34.487 10.7415H12.2984C10.4789 10.7415 9 12.2009 9 13.9968V33.5298C9 35.3257 10.4789 36.7854 12.2984 36.7854ZM10.7991 13.9968C10.7991 13.1811 11.472 12.5172 12.2984 12.5172H34.487C35.3134 12.5172 35.9863 13.1811 35.9863 13.9968V33.5298C35.9863 34.3455 35.3134 35.0096 34.487 35.0096H12.2984C11.472 35.0096 10.7991 34.3455 10.7991 33.5298V13.9968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M36.8858 18.9658H9.89954C9.40299 18.9658 9 18.6588 9 18.2805C9 17.9021 9.40299 17.5951 9.89954 17.5951H36.8858C37.3824 17.5951 37.7854 17.9021 37.7854 18.2805C37.7854 18.6588 37.3824 18.9658 36.8858 18.9658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M16.5389 14.8537C16.1606 14.8537 15.8535 14.4699 15.8535 13.997V8.85671C15.8535 8.3838 16.1606 8 16.5389 8C16.9172 8 17.2242 8.3838 17.2242 8.85671V13.997C17.2242 14.4699 16.9172 14.8537 16.5389 14.8537Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M30.2459 14.8537C29.8676 14.8537 29.5605 14.4699 29.5605 13.997V8.85671C29.5605 8.3838 29.8676 8 30.2459 8C30.6242 8 30.9313 8.3838 30.9313 8.85671V13.997C30.9313 14.4699 30.6242 14.8537 30.2459 14.8537Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 119"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 9",
    x1: 14,
    y1: 23.5,
    x2: 19,
    y2: 23.5,
    stroke: "#0071C2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 10",
    x1: 21,
    y1: 23.5,
    x2: 26,
    y2: 23.5,
    stroke: "#0071C2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 13",
    x1: 28,
    y1: 23.5,
    x2: 33,
    y2: 23.5,
    stroke: "#0071C2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 9_2",
    x1: 14,
    y1: 26.5,
    x2: 19,
    y2: 26.5,
    stroke: "#0071C2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 11",
    x1: 21,
    y1: 26.5,
    x2: 26,
    y2: 26.5,
    stroke: "#0071C2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 14",
    x1: 28,
    y1: 26.5,
    x2: 33,
    y2: 26.5,
    stroke: "#0071C2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 9_3",
    x1: 14,
    y1: 29.5,
    x2: 19,
    y2: 29.5,
    stroke: "#0071C2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 12",
    x1: 21,
    y1: 29.5,
    x2: 26,
    y2: 29.5,
    stroke: "#0071C2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 15",
    x1: 28,
    y1: 29.5,
    x2: 33,
    y2: 29.5,
    stroke: "#0071C2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarButtonIcon);
export default __webpack_public_path__ + "static/media/calendarButtonIcon.10248c21bd39ca7552793e65284399ce.svg";
export { ForwardRef as ReactComponent };